import { registerDefaultProps, registerUiConfigComponent } from 'ui/uiConfig/factory'
import type { EditTimeSeriesProps } from './EditTimeSeries.types'

// Re-export for use in other modules
export type { EditTimeSeriesProps }

registerUiConfigComponent(`edit_time_series`, () => <div />, { isSingletonComponent: true })

registerDefaultProps('edit_time_series', {
  items: [],
} satisfies EditTimeSeriesProps)
